import type MapView from '@arcgis/core/views/MapView';
import {
	extractLngLatPositions,
	type ValidGeometry,
} from '@Map/extractLngLatPositions';
import { boundsAreNotInitialized, convertCoordsToBounds } from '@Map/utils';
import type { FitBoundsOptions } from '@Map/types';
import EsriUtils from './esriHelpers';

/** Frames the map to the union extent of the given GeoJSON geometries (EPSG:4326). */
export function fitViewToGeoJSONGeometries(
	view: MapView,
	geometries: GeoJSON.Geometry[],
	fitBoundsOptions?: FitBoundsOptions,
): void {
	const valid = geometries.filter((g): g is ValidGeometry => {
		return !!g && 'coordinates' in g;
	});
	if (!valid.length) return;

	const coords = extractLngLatPositions(valid);
	const bounds = convertCoordsToBounds(coords);
	if (boundsAreNotInitialized(bounds)) return;
	if (bounds.getNorth() === bounds.getSouth()) {
		view.goTo({
			target: EsriUtils.lngLatToPoint(bounds.getCenter()),
			zoom: fitBoundsOptions?.maxZoom ?? 18,
		});
	} else {
		const promise = view.goTo(EsriUtils.boundsToExtent(bounds));
		if (fitBoundsOptions?.maxZoom !== undefined) {
			const { maxZoom } = fitBoundsOptions;
			void promise.then(() => {
				if (view.zoom > maxZoom) {
					void view.goTo({ zoom: maxZoom }, { duration: 0 });
				}
			});
		}
	}
}
